import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const DisclosureOfPartyTransaction = () => {
  const pageid = 12; // 🔑 set correct pageid for disclosure party transaction
  const [disclosures, setDisclosures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDisclosures = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setDisclosures([]);
          return;
        }

        // format API data
        const formatted = result.data.map((item) => ({
          label: item.pdf_name,
          file: item.upload_file_path,
        }));

        setDisclosures(formatted);
      } catch (error) {
        console.error("Fetch failed:", error);
        setDisclosures([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDisclosures();
  }, []);

  return (
    <>
      <Helmet>
        <title>Disclosure Of Related Party Transaction | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative bg-[#193267] p-28 px-4 sm:px-8 md:px-16 lg:px-32 w-full">
        <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
          Disclosure of Related Party Transaction
        </h1>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading disclosures...</p>
        ) : disclosures.length === 0 ? (
          <p>No disclosures found.</p>
        ) : (
          <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
            {disclosures.map((item, idx) => (
              <li key={idx}>
                <a
                  href={`${API_PDF_URL}/${item.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Footer />
    </>
  );
};

export default DisclosureOfPartyTransaction;
